import React from 'react';
import ChartComponent from './FollowerChart';

const DashboardPreview = () => {
  const interests = [
    { label: '🌍 Everyone', active: false },
    { label: '💪 Fitness', active: true },
    { label: '✈️ Travel', active: false },
    { label: '👗 Fashion', active: false },
    { label: '💻 Technology', active: false },
    { label: '🍔 Food', active: false },
    { label: '🎵 Music', active: false },
    { label: '🎨 Art', active: false },
    { label: '🎮 Gaming', active: false },
    { label: '📸 Photography', active: false },
    { label: '🌿 Health & Wellness', active: true },
    { label: '😂 Memes/Humor', active: false },
    { label: '🏎️ Cars', active: false },
    { label: '📚 Books', active: false },
  ];

  return (
    <div className="bg-white rounded-2xl md:rounded-3xl overflow-hidden mx-auto"
      style={{
        border: '1px solid #e3e8ee',
        boxShadow: '0 8px 30px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)',
        maxWidth: '880px',
      }}>

      {/* Tabs */}
      <div className="px-4 pt-4 md:px-6 md:pt-5">
        <div className="flex rounded-xl p-1" style={{ background: '#f6f9fc', border: '1px solid #e3e8ee', gap: '3px' }}>
          {[
            { icon: 'fa-magnet', label: 'Magnet', active: true },
            { icon: 'fa-rocket', label: 'Instant Boosts', active: false },
            { icon: 'fa-microchip', label: 'AI Tools', active: false },
          ].map((tab) => (
            <div key={tab.label} className="flex-1 flex items-center justify-center gap-1.5 py-2 px-2 md:px-3 rounded-lg whitespace-nowrap"
              style={{
                fontSize: '0.78rem',
                fontWeight: tab.active ? 600 : 500,
                color: tab.active ? '#fff' : '#425466',
                background: tab.active ? 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)' : 'transparent',
                boxShadow: tab.active ? '0 4px 6px rgba(50,50,93,0.11)' : 'none',
              }}>
              <i className={`fas ${tab.icon}`} style={{ fontSize: '0.65rem' }}></i>
              {tab.label}
            </div>
          ))}
        </div>
      </div>

      {/* Profile Row + Stats */}
      <div className="px-4 pt-3 md:px-6 md:pt-4">
        <div className="rounded-xl p-3 md:p-4" style={{ border: '1px solid #e3e8ee', boxShadow: '0 2px 4px rgba(50,50,93,0.06)' }}>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            {/* Profile Info */}
            <div className="flex items-center gap-2.5 sm:min-w-0 sm:flex-shrink-0">
              <div className="w-9 h-9 rounded-full flex items-center justify-center text-lg flex-shrink-0"
                style={{ background: 'linear-gradient(135deg, #635bff, #7c3aed)' }}>😎</div>
              <div className="min-w-0">
                <div className="font-bold text-sm truncate" style={{ color: '#0a2540' }}>@yourhandle</div>
                <div className="flex gap-1.5 items-center mt-0.5">
                  <span className="text-white font-bold rounded-md px-1.5 flex-shrink-0" style={{
                    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                    fontSize: '0.55rem', padding: '1px 6px',
                  }}>👑 PRO</span>
                  <span className="flex items-center gap-1 rounded-md flex-shrink-0" style={{
                    background: '#ecfdf5', color: '#059669',
                    fontSize: '0.55rem', fontWeight: 600, padding: '1px 6px',
                    border: '1px solid #a7f3d0',
                  }}>
                    <span className="w-1 h-1 rounded-full" style={{ background: '#10b981' }}></span>
                    ACTIVE
                  </span>
                </div>
              </div>
            </div>

            {/* Follower Stats */}
            <div className="grid grid-cols-3 gap-2 sm:flex-1 sm:max-w-xs sm:ml-auto">
              {[
                { label: '24H', value: '+100' },
                { label: '1W', value: '+700' },
                { label: '1M', value: '+3,500' },
              ].map((stat) => (
                <div key={stat.label} className="rounded-lg text-center py-1.5 px-1"
                  style={{ background: '#f6f9fc', border: '1px solid #e3e8ee' }}>
                  <div className="font-bold text-sm" style={{ color: '#1a7f4b' }}>{stat.value}</div>
                  <div className="font-semibold" style={{ color: '#0a2540', fontSize: '0.65rem' }}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Projected Growth */}
      <div className="px-4 pt-3 md:px-6 md:pt-4">
        <div className="rounded-xl p-3 md:p-4" style={{ border: '1px solid #e3e8ee', boxShadow: '0 2px 4px rgba(50,50,93,0.06)' }}>
          <div className="font-bold text-sm mb-0.5" style={{ color: '#0a2540' }}>Projected Growth</div>
          <div className="mb-2" style={{ color: '#425466', fontSize: '0.78rem' }}>
            Your account will reach <strong style={{ color: '#0a2540' }}>120,805</strong> followers.
          </div>

          <ChartComponent followers={117805} growthRate={"100"} days={30} />

          <div className="flex justify-center mt-2">
            <div className="inline-flex rounded-lg p-0.5" style={{ background: '#f6f9fc', border: '1px solid #e3e8ee', gap: '2px' }}>
              {['1M', '6M', '1Y'].map((period) => (
                <div key={period} className="rounded-md" style={{
                  padding: '3px 14px',
                  fontSize: '0.7rem',
                  fontWeight: period === '1M' ? 600 : 500,
                  color: period === '1M' ? '#fff' : '#425466',
                  background: period === '1M' ? 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)' : 'transparent',
                  boxShadow: period === '1M' ? '0 2px 4px rgba(99,91,255,0.2)' : 'none',
                }}>
                  {period}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Target Interests */}
      <div className="p-4 md:px-6 md:pb-5">
        <div className="rounded-xl p-3 md:p-4" style={{ border: '1px solid #e3e8ee', boxShadow: '0 2px 4px rgba(50,50,93,0.06)' }}>
          <div className="font-bold text-sm mb-0.5" style={{ color: '#0a2540' }}>Target Interests</div>
          <div className="mb-2" style={{ color: '#425466', fontSize: '0.78rem' }}>
            ViralGPT uses AI to recognize your interests from your bio & posts.
          </div>
          <div className="flex flex-wrap gap-1.5 rounded-lg p-2" style={{ background: '#f6f9fc', border: '1px solid #e3e8ee' }}>
            {interests.map((interest) => (
              <span key={interest.label} className="rounded-md whitespace-nowrap" style={{
                padding: '3px 10px',
                fontSize: '0.75rem',
                fontWeight: interest.active ? 600 : 400,
                background: interest.active ? 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)' : '#fff',
                color: interest.active ? '#fff' : '#425466',
                border: interest.active ? '1px solid transparent' : '1px solid #e3e8ee',
                boxShadow: interest.active ? '0 2px 4px rgba(99,91,255,0.2)' : 'none',
              }}>
                {interest.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPreview;
